export const EVENT_ISSUABLE_VUE_APP_CHANGE = 'issuable_vue_app:change';
